module.exports = __webpack_public_path__ + "media/2x/E-3e109c32.png";